import { render, staticRenderFns } from "./ReportPwbCompoment.vue?vue&type=template&id=c5166ca6&scoped=true"
import script from "./ReportPwbCompoment.vue?vue&type=script&lang=js"
export * from "./ReportPwbCompoment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5166ca6",
  null
  
)

export default component.exports